<template>
    <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
            <div v-if="errorMessage != null">
                <base-alert type="danger" dismissible>
                    <span class="alert-inner--text"> {{errorMessage}}</span>
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                       <span aria-hidden="true">&times;</span>
                    </button>
                </base-alert>
            </div>
            <div v-if="successMessage != null">
                <base-alert type="primary" dismissible>
                    <span class="alert-inner--text"> {{successMessage}}</span>
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                       <span aria-hidden="true">&times;</span>
                    </button>
                </base-alert>
            </div>

            <div class="card bg-secondary shadow border-0">
                
                <div class="card-body px-lg-5 py-lg-5">
                    <div class="text-center text-muted mb-4">
                        <h2>Password Reset</h2>
                    </div>
                    <form role="form">

                        <small>
                            Please input the email tagged to your account. 
                        </small> <br><br>
                        
                        <base-input class="input-group-alternative mb-3"
                                    placeholder="Account Name"
                                    addon-left-icon="ni ni-building"
                                    v-model="model.account">
                        </base-input>
                        
                        <base-input class="input-group-alternative mb-3"
                                    placeholder="Email"
                                    addon-left-icon="ni ni-email-83"
                                    v-model="model.email">
                        </base-input>

                        <div class="text-center">
                            <base-button @click.prevent="passwordReset" type="danger" class="my-4">Reset Password</base-button><br>
                            <a @click.prevent="backTologin" class="text-dark"><small>Login to your account</small></a>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HTTPRequest from '../controllers/httpRequest.js'
import { mapState } from 'vuex'
  export default {
    computed: {
        ...mapState(['endPoint']),
    },
    name: 'register',
    data() {
      return {
        model: {
          email: '',
          account: '',
        },
        errorMessage: null,
        successMessage: null
      }
    },
    methods: {
        backTologin(){
            this.$router.go(-1)
        },
        async passwordReset(){
           this.errorMessage = null;
           this.successMessage = null;
           var passwordResetPayload = {email: this.model.email, account_name: this.model.account}
           var post_request = await HTTPRequest.postRequest(this.endPoint + 'users/reset_password', null, passwordResetPayload) 
           // eslint-disable-next-line 
           console.log(post_request)  
           if(post_request["success"] == undefined){
               this.errorMessage = post_request["error"]
            //    this.errorMessage = "It seems you've entered wrong credentials. Please try again."
               //alert("Invalid email")
           } else {
                // alert(post_request['success'])
                this.model.email = ""
                this.model.account = ""
                this.successMessage = post_request['success']
           }
           
        }
    }
  }
</script>
<style>
</style>
